import { defineStore } from 'pinia'
export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        token: localStorage.getItem('token') || null
    }),
    actions: {
        setToken(token) {
            this.token = token
            localStorage.setItem('token', token)
        },
        logout() {
            this.token = null
            this.user = null
            localStorage.removeItem('token')
        },
        async fetchUser() {
            // Optional: fetch profile from /me endpoint
        },
        isAuthenticated() {
            return !!this.token
        }
    }
})